import { getItemFromStore, setItemToStore } from 'helpers/utils';
import { appsList } from 'components/layouts/breadcrumb/breadcrumbHelpers';

/**
 * Quản lý "app hay sử dụng" cho command-palette search.
 * Đếm số lần mở mỗi app, lưu localStorage; getFrequentApps trả top hay dùng nhất.
 */
const STORAGE_KEY = 'peb:appUsage';

// path -> {to,label} để lọc app hợp lệ (còn tồn tại trong siteMaps).
const appByPath = appsList.reduce((acc, app) => {
  acc[app.to] = app;
  return acc;
}, {});

// App mặc định khi chưa có lịch sử dùng (chỉ giữ app thực có trong catalog).
const DEFAULT_PATHS = [
  '/dashboard/crm',
  '/crm/projects/list',
  '/crm/customers/list',
  '/crm/contacts/list',
  '/crm/leads/list',
  '/drives/list'
];

const readUsage = () => getItemFromStore(STORAGE_KEY, {}) || {};

// Tăng đếm khi user mở 1 app từ modal.
export const recordAppUsage = to => {
  if (!to) return;
  const usage = readUsage();
  usage[to] = (usage[to] || 0) + 1;
  setItemToStore(STORAGE_KEY, JSON.stringify(usage));
};

// Trả danh sách app hay dùng (giảm dần theo số lần), bù mặc định cho đủ `limit`.
export const getFrequentApps = (limit = 8) => {
  const usage = readUsage();

  const used = Object.keys(usage)
    .filter(to => appByPath[to])
    .sort((a, b) => usage[b] - usage[a])
    .map(to => appByPath[to]);

  const defaults = DEFAULT_PATHS.filter(to => appByPath[to]).map(
    to => appByPath[to]
  );

  const seen = new Set();
  const result = [];
  // used -> defaults -> toàn bộ catalog (đảm bảo luôn đủ số lượng)
  for (const app of [...used, ...defaults, ...appsList]) {
    if (app && !seen.has(app.to)) {
      seen.add(app.to);
      result.push(app);
    }
    if (result.length >= limit) break;
  }
  return result;
};
